export class FormFieldGroup {
  public constructor() {
    this.intialize();
  }

  public intialize() {
    this.Name = '';
    //this.TableNames = new Array<string>();
    this.DisplayName = '';
    this.FieldGroupType = 0;
    //this.Fields = new Array<any>();
  }

  public Name: string;
  //public TableNames: Array<string>
  public DisplayName: string;
  public FieldGroupType: number;
  //public Fields: Array<any>
}
